import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

const providers = [
  { provide: 'BASE_URL', useValue: environment.API_URL },
  { provide: 'WEB_URL', useValue: environment.WEB_URL },
  { provide: 'DOC_URL', useValue: environment.DOC_URL },
  { provide: 'EMAIL_SERVER_ACTIVE', useValue: environment.EMAIL_SERVER_ACTIVE },
];

platformBrowserDynamic(providers).bootstrapModule(AppModule)
  .catch(err => console.error(err));
